import ConsumerGroups from './ConsumerGroups';
import './ConsumerGroups.scss';

export default ConsumerGroups;